import { Lock } from 'lucide-react';

// The one lock marker. Sidebar footer rows (panel-shell.tsx), locked nav
// children, and the layer-landing cards all mark "on a higher plan" the same
// way — a lucide icon plus the word, never an emoji glyph (design audit T10:
// emoji render at the mercy of the platform's font and carry no accessible
// name of their own).
//
// `withLabel={false}` where the caller already shows a visible "Locked" next
// to the marker (layer-landing's cards): the sr-only copy would otherwise be
// read out twice in a row. Everywhere the icon stands alone, keep the label —
// it IS the marker's accessible name.
export function LockMarker({ withLabel = true }: { withLabel?: boolean }) {
  return (
    <span className="inline-flex items-center text-xs">
      <Lock className="h-3 w-3" aria-hidden="true" />
      {withLabel ? <span className="sr-only">Locked</span> : null}
    </span>
  );
}
